import React, { memo, useEffect } from 'react'

import {
  GlobalEventContentType,
  useCaptureDialogToggleEvent,
} from '@surglogs-app/analytics'
import { DefaultDialog } from '@surglogs-app/ui.dialog'

interface UnsavedChangesDetectedDialogProps {
  answer: (answer: boolean) => void
  onConfirm: () => void
  clearStorageData: () => void
  analyticsContentType: GlobalEventContentType
  labels: {
    title: string
    confirmButtonLabel?: string
    cancelButtonLabel?: string
  }
}

export const UnsavedChangesDetectedDialog = memo(
  ({
    answer,
    onConfirm,
    clearStorageData,
    analyticsContentType,
    labels: { title, confirmButtonLabel, cancelButtonLabel },
  }: UnsavedChangesDetectedDialogProps) => {
    const { captureDialogToggleEvent } = useCaptureDialogToggleEvent()

    useEffect(() => {
      const eventPayload = {
        action: 'unsaved_changes',
        content_type: analyticsContentType,
        dialog_type: 'default',
      } as const

      captureDialogToggleEvent('open', eventPayload)

      return () => {
        captureDialogToggleEvent('close', eventPayload)
      }
    }, [captureDialogToggleEvent, analyticsContentType])

    return (
      <DefaultDialog
        {...{
          onConfirm: () => {
            onConfirm()
            answer(true)
          },
          onCancel: () => {
            clearStorageData()
            answer(false)
          },
          title,
          confirmButtonLabel,
          cancelButtonLabel,
        }}
      />
    )
  },
)
